module.exports = __webpack_public_path__ + "img/new_33.470f8c62.jpg";